module.exports = __webpack_public_path__ + "img/07.eb33bbfd.jpg";